module.exports = __webpack_public_path__ + "img/智慧水利综合管理平台系统V1.0.15afcb8d.jpg";